var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPsp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PSP",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.396,
    height: 38.935,
    viewBox: "0 0 29.396 38.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M347.281,108.77H332.226l-9.506,9.506.012,1.48,2.037-.017v-.025h9.01v-8.907h13.5a2.8,2.8,0,0,1,2.8,2.8V142.87a2.8,2.8,0,0,1-2.8,2.8H327.557a2.8,2.8,0,0,1-2.8-2.8V125.664h-2.037V142.87a4.841,4.841,0,0,0,4.836,4.835h19.724a4.841,4.841,0,0,0,4.835-4.835V113.605A4.841,4.841,0,0,0,347.281,108.77ZM326.2,117.676l5.542-5.542v5.542Z",
    transform: "translate(-322.72 -108.77)",
    fill: "#ec0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 2.037,
    height: 2.128,
    transform: "translate(0.003 12.635)",
    fill: "#ec0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 18.319,
    height: 1.823,
    transform: "translate(5.539 12.635)",
    fill: "#ec0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18.319,
    height: 1.823,
    transform: "translate(5.539 16.635)",
    fill: "#ec0000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 18.319,
    height: 1.823,
    transform: "translate(5.539 20.635)",
    fill: "#ec0000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 18.319,
    height: 1.823,
    transform: "translate(5.539 24.635)",
    fill: "#ec0000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 18.319,
    height: 1.823,
    transform: "translate(5.538 28.635)",
    fill: "#ec0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsp);
export default __webpack_public_path__ + "static/media/PSP.b26519d938e1833c824c2dbc1bcfd8c6.svg";
export { ForwardRef as ReactComponent };